import React, { useMemo, useState, useEffect } from 'react';
import { Card, Col, Row, Button } from 'react-bootstrap';
import { useParams } from "react-router-dom";
import PageTitle from '../../includes/PageTitle';
import Tables from "../../components/Tables/Tables";
import Modals from "../../components/Modals/Modals";
import Alert from 'react-bootstrap/Alert';
import { useFormik } from 'formik';
import { ToastContainer, toast } from 'react-toastify';
import Loader from '../../components/Loader/Loader';
import { postDesignationPosition, getPositionDetails, patchPositionUpdate, deletePosition, postDesignationAdd } from '../../apiservices/ApiServices';

const Designation = () => {
    const [show, setShow] = useState(false);
    const [isLoading, setLoading] = useState(true);
    const [isLoadings, setLoadings] = useState(false);
    const [addModal, setAddModal] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [data, setData] = useState([]);
    const { id } = useParams();

    const postDesignationPositions = async (postData) => {
        setLoading(true);
        try {
            const res = await postDesignationPosition(id, postData);
            setData(res.data.data);
            setLoading(false);
            console.log(res.data.data)

        } catch (error) {
            setLoading(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const postUpdateDesignations = async () => {
        let postData = {
            length: 100
        }
        try {
            const res = await postDesignationPosition(id, postData);
            setData(res.data.data);

        } catch (error) {
            console.log(error.response?.data?.message || "Error submitting data");
        }
    };

    useEffect(() => {
        let postData = {
            length: 100
        }
        postDesignationPositions(postData);
    }, [id]);

    const columns = useMemo(
        () => [
            {
                Header: "Designation/Role Name",
                accessor: "name",
            },
            {
                Header: "Action",
                accessor: "action",
                disableSortBy: true,
            },
        ],
        []
    );

    const actions = ['edit', 'delete']
    const subActions = []

    const emptyStatement = {
        eId: '',
        eName: '',
        eDescription: '',
        designations: {
            name: '',
            description: '',
        }
    };

    const [initialFormikValues, setInitialFormikValues] = useState({
        designations: [emptyStatement]
    });

    const add = () => {
        setFieldValue('designations', [...values.designations, { ...emptyStatement }]);
    };

    const remove = (index) => {
        const updated = values.designations.filter((_, i) => i !== index);
        setFieldValue('designations', updated);
    };

    const transformFormValuesToPostData = (values) => {
        return {
            position_id: id,
            designations: values.designations.map((item) => ({
                name: item?.name,
                description: item?.description
            })),
        };
    };

    const formik = useFormik({
        initialValues: initialFormikValues,
        validationSchema: '',
        onSubmit: async (values) => {
            setLoadings(true);

            if (addModal) {
                const postData = transformFormValuesToPostData(values);
                try {
                    const res = await postDesignationAdd(postData);
                    toast.success(res.data.message);
                    postUpdateDesignations();
                    setLoadings(false);
                    setAddModal(false);
                    formik.resetForm();
                } catch (error) {
                    setLoadings(false);
                    toast.error(error.response?.data?.message || "Error submitting data");
                }
            }

            if (editModal) {
                let postData = {
                    name: values.eName,
                    description: values.eDescription,
                }

                try {
                    const res = await patchPositionUpdate(values.eId, postData);
                    toast.success(res.data.message);
                    setLoadings(false);
                    postUpdateDesignations();
                    setEditModal(false);
                    formik.resetForm();
                } catch (error) {
                    setLoadings(false);
                    toast.error(error.response?.data?.message || "Error submitting data");
                }
            }
        },
    });

    const { values, handleChange, handleBlur, handleSubmit, setFieldValue, errors, touched } = formik;


    const handleConfirm = () => {
        setAddModal(false);
        setEditModal(false);
        formik.resetForm();
    };

    const handleEdit = async (rowData) => {
        setLoadings(true);
        try {
            const res = await getPositionDetails(rowData?.position_id);
            setFieldValue('eId', res.data.data.position_id);
            setFieldValue('eName', res.data.data.name);
            setFieldValue('eDescription', res.data.data.description);

            setLoadings(false);
            setEditModal(true);

        } catch (error) {
            setLoadings(false);
            setEditModal(false);
        }
    };

    const handleDelete = (rowData) => {
        setShow(true);
        setFieldValue('eId', rowData?.position_id);
        setFieldValue('eName', rowData?.name);
    };

    const handleDeleteCon = async () => {
        setLoadings(true);
        try {
            const res = await deletePosition(values.eId);
            toast.success(res.data.message);
            setLoadings(false);
            setShow(false);
            postUpdateDesignations();
            setFieldValue('eId', '');
            setFieldValue('eName', '');
        } catch (error) {
            setLoadings(false);
            setShow(false);
        }

    };

    return (
        <>
            <ToastContainer
                position="top-right"
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{ zIndex: 9999999999, position: 'fixed' }}
            />
            {isLoading ? <Loader /> :
                <>
                    <PageTitle titles={data?.function?.name + ' - Designation/Role'} active={data?.function?.name + ' - Designation/Role'} items={['Home']} />
                    <Row>
                        <Col sm={12} className="col-12">
                            <Card>
                                <Card.Body className="example1-table">
                                    <div className='custompageHed'>
                                        <Row>
                                            <Col md={6}>
                                                <div className='pagetitle_hed'>
                                                    <h1>{data?.function?.name} - Designation/Role</h1>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className='w-100 d-flex justify-content-end'>
                                                    <Button variant="primary" onClick={() => setAddModal(true)}>Add New</Button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                    <Tables
                                        columns={columns}
                                        data={data?.records}
                                        actions={actions}
                                        subActions={subActions}
                                        onEdit={handleEdit}
                                        onDelete={handleDelete}
                                    />
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </>
            }

            <Modals
                show={addModal}
                handleClose={() => setAddModal(false)}
                title="Add New"
                textColor='#000'
                size='lg'
                centered={true}
                backdrop={true}
                onConfirm={handleConfirm}
            >
                <form onSubmit={handleSubmit} autoComplete="off">
                    {values.designations.map((designations, index) => (
                        <div key={index} className="fieldsets mainFS">
                            <div className='fieldsetsboxs'>
                                <h6>Designation/Role {index + 1}</h6>
                                <div className="addreovebtns">
                                    <button type="button" className="btn add-btn" onClick={add}>+</button>
                                    {values.designations.length > 1 && (
                                        <button type="button" className="btn remove-btn" onClick={() => remove(index)}>-</button>
                                    )}
                                </div>
                            </div>
                            <div className='formsBox'>
                                <Row>
                                    <Col md={6}>
                                        <div className="form-group">
                                            <label className="form-label">Name</label>
                                            <input type="text"
                                                name="name"
                                                className="form-control"
                                                autoComplete='off'
                                                value={designations.name}
                                                onChange={(e) => setFieldValue(`designations[${index}].name`, e.target.value)}
                                            />
                                            {errors?.designations?.[index]?.name &&
                                                touched?.designations?.[index]?.name && (
                                                    <p className="errormsg">{errors.designations[index].name}</p>
                                                )}
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="form-group">
                                            <label className="form-label">Description</label>
                                            <input type="text"
                                                name="description"
                                                className="form-control"
                                                autoComplete='off'
                                                value={designations.description}
                                                onChange={(e) => setFieldValue(`designations[${index}].description`, e.target.value)}
                                            />
                                            {errors?.designations?.[index]?.description &&
                                                touched?.designations?.[index]?.description && (
                                                    <p className="errormsg">{errors.designations[index].description}</p>
                                                )}
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    ))}
                    <div className='modalfooters'>
                        <div className='button-boxs grid'>
                            <button type='submit' className='btn btn-primary'>Save</button>
                            <button type='button' onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </form>
            </Modals>

            <Modals
                show={editModal}
                handleClose={() => setEditModal(false)}
                title="Edit Designation/Role"
                textColor='#000'
                size='lg'
                centered={true}
                backdrop={true}
                onConfirm={handleConfirm}
            >
                <form onSubmit={handleSubmit} autoComplete="off">
                    <Row>
                        <Col md={12}>
                            <div className="form-group">
                                <label className="form-label">Name</label>
                                <input
                                    type='text'
                                    id="eName"
                                    name="eName"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.eName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.eName && touched.eName && (
                                    <p className="errormsg">{errors.eName}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="form-group">
                                <label className="form-label">Description</label>
                                <textarea
                                    type='text'
                                    id="eDescription"
                                    name="eDescription"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.eDescription}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.eDescription && touched.eDescription && (
                                    <p className="errormsg">{errors.eDescription}</p>
                                )}
                            </div>
                        </Col>
                    </Row>
                    <div className='modalfooters'>
                        <div className='button-boxs grid'>
                            <button type='submit' className='btn btn-primary'>Update</button>
                            <button type='button' onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </form>
            </Modals>



            {show ? (<>
                <Alert variant="danger" onClose={() => setShow(false)} dismissible>
                    <Alert.Heading>Are you sure want to Delete <span>{values.sectoreName}</span> Designation/Role?</Alert.Heading>
                    <hr />
                    <div className='button-boxs grid'>
                        <div>
                            <button onClick={() => handleDeleteCon()} className='btn btn-primary'>OK</button>
                        </div>
                        <div>
                            <button onClick={() => setShow(false)} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </Alert>
                <div className='overly'></div>
            </>) : null}

            {isLoadings && <Loader />}
        </>
    )
}

export default Designation